import Table, { ColumnsType } from "antd/es/table";
import { localizeDateTime } from "../../utils";
import { Button, Popconfirm } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";

const OrderItemTable = (props: any) => {
  const {
    data,
    title,
    onUpdateOrderItemModal,
    onDeleteOrderItem,
    addPaidOrderItemButton,
    addUnpaidOrderItemButton,
    assignmentId,
    canEditOrderItem,
    enableAdditionalCharges
  } = props;

  const columns: ColumnsType<any> = [
    {
      title: "Order item type",
      dataIndex: "order_item_type",
      key: "order_item_type",
      render: (order_item_type) => <>{order_item_type?.name}</>
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      key: "quantity"
    },
    {
      title: "Rate",
      dataIndex: "rate",
      key: "rate"
    },
    {
      title: "Additional charges",
      dataIndex: "additional_charges",
      key: "additional_charges"
    },
    {
      title: "Total item cost",
      dataIndex: "total_item_cost",
      key: "total_item_cost"
    },
    {
      title: "Tax",
      dataIndex: "tax",
      key: "tax"
    },
    {
      title: "Final amount",
      dataIndex: "final_amount",
      key: "final_amount",
      render: (_, order_item: any) => {
        return (Number(order_item.total_item_cost) * (1 + Number(order_item.tax) / 100)).toFixed(2);
      }
    },
    {
      title: "Actual quantity used",
      dataIndex: "actual_quantity_used",
      key: "actual_quantity_used"
    },
    {
      title: "Is customer accepted?",
      dataIndex: "customer_accepted",
      key: "customer_accepted",
      render: (customer_accepted: any) => {
        return customer_accepted ? "YES" : "NO";
      }
    },
    {
      title: "Is customer paid?",
      dataIndex: "customer_paid",
      key: "customer_paid",
      render: (customer_paid: any) => {
        return customer_paid ? "YES" : "NO";
      }
    },
    {
      title: "Created at",
      dataIndex: "created_at",
      key: "created_at",
      render: (created_at) => <>{created_at ? localizeDateTime(created_at) : "-"}</>
    },
    {
      title: "Updated By",
      dataIndex: "updated_by",
      key: "updated_by",
      render: (updated_by) => <>{updated_by?.name}</>
    },
    {
      title: "Updated at",
      dataIndex: "updated_at",
      key: "updated_at",
      render: (updated_at) => <>{updated_at ? localizeDateTime(updated_at) : "-"}</>
    },
    {
      title: "Action",
      key: "action",
      render: (_: any, order_item: any) => (
        <>
          {canEditOrderItem && (
            <>
              <Button
                icon={<EditOutlined />}
                onClick={() => onUpdateOrderItemModal(order_item)}
                title="Update"
              ></Button>
              <Popconfirm
                title="Are you sure you want to delete OrderItem"
                okText="Delete"
                placement="bottom"
                cancelText="Cancel"
                onConfirm={(event) => {
                  onDeleteOrderItem(assignmentId, order_item.id);
                }}
                onCancel={(event: any) => event.stopPropagation()}
              >
                <Button icon={<DeleteOutlined />} title="Delete"></Button>
              </Popconfirm>
            </>
          )}
        </>
      )
    }
  ];

  return (
    <div style={{ marginTop: 20 }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between"
        }}
      >
        <h2 style={{ margin: 0 }}>{title}</h2>

        {canEditOrderItem && (
          <div style={{ display: "flex", gap: "8px" }}>
            {addPaidOrderItemButton}
            {addUnpaidOrderItemButton}
          </div>
        )}
      </div>

      <Table
        rowKey="id"
        bordered
        columns={columns}
        pagination={false}
        dataSource={data}
        scroll={{ x: 400 }}
      />
    </div>
  );
};

export default OrderItemTable;
